import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import './home.css';
import Banner from './Banner';
import Course from '../course/Course'
import OursUsp from './OurUsp'
import Testimonial from './Testimonial';
import Loader from '.././../util/preloader/Preloader';
import EnqueryForm from './../enquery/EnqueryForm';
import Faqs from "../faqs/Faqs";
import JoinUs from "../joinUs/JoinUs";
import ScrollToTopButton from "../layout/ScrollToTopButton";
import CourseRequest from "./CourseRequest";
import FinlabsBanner from "./FinlabsBanner";



const Home = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await new Promise(resolve => setTimeout(resolve, 3000));
            setLoading(false);
        };
        getQueryParam('id');
        fetchData();
    }, []);

    const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(param);

    const obj = {
        existingFlag: paramValue ? true : false,
        userId: paramValue ? paramValue : null,
    };

    localStorage.setItem('userObj', JSON.stringify(obj));
};


    return (
        <React.Fragment>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Header />

                {/* <EnqueryForm/> */}

                    <Banner />
                    <Course mainSecTitle="" />
                    <CourseRequest />
                    <OursUsp />
                    {/* <Testimonial /> */}
                    <FinlabsBanner />
                    <Faqs />
                    <JoinUs/>
                    <Footer/>
                    <ScrollToTopButton />
                </>
            )}
        </React.Fragment>
    );
}

export default Home;